import dynamic from 'next/dynamic'
import { Box, Typography } from '@mui/material'

// Types
import type { SignupBenefitProps } from '@/types/components/molecules/signup/benefit'

// Components
const MenuItemIconAtom = dynamic(() => import('@/components/atoms/icon/menu-item'))

// One reason to sign up: icon, title and a short line
const SignupBenefitMolecule = (props: SignupBenefitProps) => {
	// Props
	const { icon, title, description } = props

	return (
		<Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
			<Box
				sx={{
					flexShrink: 0,
					display: 'grid',
					placeItems: 'center',
					width: 44,
					height: 44,
					borderRadius: 3,
					bgcolor: 'primary.light',
					color: 'primary.main',
					'& svg': { fontSize: 22 }
				}}
			>
				<MenuItemIconAtom name={icon} />
			</Box>

			<Box>
				<Typography sx={{ fontSize: 16, fontWeight: 700 }}>{title}</Typography>

				<Typography sx={{ mt: 0.5, fontSize: 14, lineHeight: 1.8, color: 'text.secondary' }}>{description}</Typography>
			</Box>
		</Box>
	)
}

export default SignupBenefitMolecule
